import { isValidInternalUrl } from '../chatRedirectValidation';

/**
 * Answers deep-link with absolute URLs built from the account host, so a link back into
 * this app has to be recognised by host and routed in-app instead of opening a tab. The
 * scheme is not compared -- those URLs are always written as https, while local dev
 * serves the app over http.
 */
export const toInternalPath = (url: string): string | null => {
  if (isValidInternalUrl(url)) return url;

  try {
    const parsed = new URL(url);
    if (parsed.host !== window.location.host) return null;

    const path = `${parsed.pathname}${parsed.search}${parsed.hash}`;
    return isValidInternalUrl(path) ? path : null;
  } catch {
    return null;
  }
};
